import React, { ForwardRefRenderFunction, forwardRef } from 'react';
import { Input } from '@firesoon/antd';
import classnames from 'classnames';
import AntdPassword from '@firesoon/antd/lib/input/Password';
import { FSPasswordProps } from './interface';

const { Password } = Input;

const Index: ForwardRefRenderFunction<AntdPassword, FSPasswordProps> = (props, ref) => {
  return (
    <Password
      className={classnames('fs-password', {
        'fs-input-not-disabled': !props?.disabled,
      })}
      placeholder="请输入内容"
      allowClear
      ref={ref}
      {...props}
    />
  );
};

export default forwardRef(Index);
